import { Connection } from '../connections/connection'
import { FlowVersion } from '../flow-version'
import { flowStructureUtil } from '../util/flow-structure-util'
import { DetachStepsRequest } from './index'


export function _attachSteps(flowVersion: FlowVersion, request: DetachStepsRequest): FlowVersion {
    const updatedFlowVersion: FlowVersion = { ...flowVersion }
    const { sourceId, targetId } = request.connection
    if (!sourceId || !targetId) return updatedFlowVersion

    const newConnection: Connection = { sourceId, targetId }
    const subflow = flowStructureUtil.findSubflowForConnection(updatedFlowVersion, sourceId, targetId)
    const targetConnections = subflow ? subflow.connections : updatedFlowVersion.connections

    if (!targetConnections.some(conn => conn.sourceId === sourceId && conn.targetId === targetId)) {
        targetConnections.push(newConnection)
    }
    return updatedFlowVersion
}
